'use client';

import React from 'react';

export interface PromoSlotInlineSkeletonProps {
  /** Tailwind height class to reserve space (e.g., 'h-6', 'h-11') */
  className?: string;
}

/**
 * Invisible placeholder for the PDP/PLK Inline Slot.
 * Reserves space to prevent layout shift without visible loading indicators.
 * Callers should pass a height class via className.
 */
const PromoSlotInlineSkeleton: React.FC<PromoSlotInlineSkeletonProps> = ({
  className,
}) => {
  return (
    <div
      className={className}
      data-testid="promo-slot-inline-skeleton"
      aria-hidden="true"
    />
  );
};

export default React.memo(PromoSlotInlineSkeleton);
